import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useStyles = makeStyles(() => ({
  expandToggle: {
    width: 18,
    height: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    color: COLORS.muted,
    cursor: 'pointer',
    flexShrink: 0,
    background: 'none',
    border: 'none',
    padding: 0,
  },
  nodeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    minWidth: 0,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  nodeIcon: {
    marginRight: 5,
    fontSize: 13,
    flexShrink: 0,
  },
}));
